module.exports = __webpack_public_path__ + "static/media/b1.907633e5.jpg";